import {http} from "../_helpers";
import Service from "./Service";

class ReportService extends Service {

    getReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports`, {}, filter));
    }

    getLawyersReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/lawyer`, {}, filter));
    }

    getLawyerDepartmentReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/lawyer/department`, {}, filter));
    }

    getLawyerEPOReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/lawyer/epo`, {}, filter));
    }

    getSourceRoiReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/roi`, {}, filter));
    }

    getPhaseAgingReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/phase-aging`, {}, filter));
    }

    getMissedCallReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/missed-calls`, {}, filter));
    }

    getCallStatsReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/call-stats`, {}, filter));
    }

    getFunnelReport(filter) {
        return http.get(this.makeOptionsUrl(`/reports/funnel`, {}, filter));
    }
}

export default new ReportService;
